import React, { useState, useEffect } from 'react'
import { useStyle } from "./Style";
import useProductCurrency from '../../../../../hooks/useProductCurrency';
import { Box, Grid } from '@mui/material';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Button from '@mui/material/Button';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import {
  getFullName,
  describeScheduleEntryMedicalConditions
} from '../../../../../lib/personDetails.es6';
import {
  policyDetailSources,
  readMemberField
} from '../../../../../lib/policyDetails.es6';
import {
  isDependantDeceased,
  rejectedDeathClaimFor
} from '../../../../../lib/claimDeceased.es6';
const Dependants = (props) => {
  const classes = useStyle();
  const currencyCode = useProductCurrency((props.policy.quotation && props.policy.quotation.product_code) || props.policy.product_code)
  const dependants = (props.policy.quotation && props.policy.quotation.policy_schedule_entries) ? props.policy.quotation.policy_schedule_entries : null
  // Conditions may be recorded once at policy level instead of on the member, and an
  // amended policy's richer snapshot sits on the quotation rather than the policy — so
  // every detail blob on the record is offered as a fallback source (retest item 3).
  const policyAdditionalDetails = policyDetailSources(props.policy)

  const [expanded, setExpanded] = useState(false)

  // Tab panels only mount when opened, so the Claims tab may never have run its
  // fetch. Without this the pill silently reads Active for a member who has died.
  useEffect(() => {
    if (props.getClaims) {
      props.getClaims()
    }
  }, [])

  const dataForDisplay = expanded ? dependants : dependants.slice(0, 2)

  // Death outranks the cover flag: a member whose death has been claimed for is
  // reported as deceased rather than as merely inactive.
  const statusOf = (entry) => {
    if (isDependantDeceased(entry.dependant, props.claims)) {
      return { label: 'Deceased', className: classes.deceasedPill }
    }
    return entry.active === true
      ? { label: 'Active', className: classes.activePill }
      : { label: 'Inactive', className: classes.inactivePill }
  }

  // A turned-down death claim leaves the member's status alone, but saying
  // nothing at all would leave an assessor wondering whether the claim was ever
  // logged. Only shown where it changes nothing else — a member with a claim
  // that stands already reads Deceased.
  const rejectedClaimNote = (entry) => {
    if (isDependantDeceased(entry.dependant, props.claims)) {
      return null
    }
    const claim = rejectedDeathClaimFor(entry.dependant, props.claims)
    if (!claim) {
      return null
    }
    return claim.claim_number
      ? 'Rejected claim ' + claim.claim_number
      : 'Rejected claim on file'
  }

  if (props.policy && dependants) {

    return (
      <>
        {
          <p style={{
            textAlign: 'right', fontFamily: "open sans",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "15px",
            color: "#000000",
            marginTop: "20px"
          }}> Total Premium : {currencyCode + " " + props.policy.quotation.total_premium_amount_in_cents / 100}</p>
        }
        {
          dataForDisplay.map((entry, index) => (
            <>
              <Grid container className={classes.policyWrapper} key={index} >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container className={classes.policyHeader}>
                    <Grid item xs={12} sm={6} md={6}>
                      <Grid container>
                        <Grid item xs={12} md={2} sm={2} className={classes.policyIconWrapper}   >
                          <Box className={classes.policyIcons}>
                            <NoteAddOutlinedIcon fontSize="14px" sx={{ color: "#ffffff" }} />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={10} sm={10} className={classes.policyHeaderContent}>
                          <h6>{getFullName(entry.dependant) || "N/A"}</h6>
                          <p> Full Name</p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} >

                      <Grid container>
                        <Grid item xs={12} md={6} sm={6}>
                          <div >

                          </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} className={classes.policyActiveStatusWrapper}>
                          <Box display="flex" justifyContent="flex-end">
                            <ul>
                              <li className={statusOf(entry).className}> <span>{statusOf(entry).label}</span></li>
                            </ul>
                          </Box>
                          {rejectedClaimNote(entry) && (
                            <Box display="flex" justifyContent="flex-end">
                              <span className={classes.rejectedClaimNote}>
                                {rejectedClaimNote(entry)}
                              </span>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    <div className={classes.policyHeaderBorder}></div>
                  </Grid>

                  <Grid container spacing={2} className={classes.policyContentWrapper}>
                    <Grid item xs={12} sm={3} md={3} >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3} md={3}></Grid>
                        <Grid item xs={12} sm={9} md={9}>
                          <p>Date Of Birth </p>
                          <h6> {entry.dependant.date_of_birth || "N/A"}</h6>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p> Gender</p>
                      {/* Read across every place it can sit — the engine drops gender
                          off dependant records (retest item 4). */}
                      <h6>{readMemberField(props.policy, entry.dependant, ['gender', 'sex']) || "N/A"}
                      </h6>

                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p>National ID</p>
                      <h6>{entry.dependant.national_id || "N/A"}</h6>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p>Town</p>
                      <h6>{
                        entry.dependant.town || "N/A"
                      }</h6>
                    </Grid>
                    {/* Phone was not shown at all even though onboarding collects it
                        for every dependant aged 18+ (retest item 4). It is the fifth
                        field in a four-up row, so it wraps onto its own line — it
                        carries the same nested indent as the other column-one
                        fields so it lines up under Date Of Birth. */}
                    <Grid item xs={12} sm={3} md={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3} md={3}></Grid>
                        <Grid item xs={12} sm={9} md={9}>
                          <p>Phone</p>
                          <h6>{readMemberField(props.policy, entry.dependant, [
                            'msisdn',
                            'phone_number',
                            'phone',
                            'contact_number'
                          ]) || "N/A"}</h6>
                        </Grid>
                      </Grid>
                    </Grid>


                  </Grid>
                  <div className={classes.policyContentBorder}></div>

                  <Grid container spacing={2} className={classes.policyContentWrapper}>
                    <Grid item xs={12} sm={3} md={3} >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3} md={3}></Grid>
                        <Grid item xs={12} sm={9} md={9}>
                          <p>Relationship </p>
                          <h6> {entry.dependant.relationship || "N/A"}</h6>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p> Work Address</p>
                      <h6>{entry.dependant.work_address || "N/A"}
                      </h6>

                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p>Postal Adress</p>
                      <h6>{entry.dependant.postal_address || "N/A"}</h6>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <p>Passport </p>
                      <h6>{
                        entry.dependant.passport || "N/A"
                      }</h6>
                    </Grid>

                  </Grid>
                  <div className={classes.policyContentBorder}></div>

                  {/* Named medical conditions declared for this member at
                      capture, so assessment can see them per dependant. */}
                  <Grid container spacing={2} className={classes.policyContentWrapper}>
                    <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: "48px" }}>
                      <p>Declared Medical Conditions</p>
                      <h6>{describeScheduleEntryMedicalConditions(
                        entry,
                        policyAdditionalDetails
                      )}</h6>
                    </Grid>
                  </Grid>
                  <div className={classes.policyContentBorder}></div>
                  <Grid container spacing={2} className={classes.policyFooterWrapper}>
                    <Grid item xs={12} sm={6} md={6} style={{paddingLeft: "48px"}}>
                      <p>Created At</p>
                      <h6>{formatDateLocale(entry.dependant.created_at) || "N/A"}</h6>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={classes.policyBalance}>
                        <p>Premiums</p>
                        <h6>{`${currencyCode}  ${entry.premium_amount_in_cents / 100}` || "0.00"}    </h6>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{paddingLeft: "48px"}}>
                      <p>Benefits</p>
                      <ol>
                        {
                          entry.benefits.map(benefit => {
                            return (
                              <li key={benefit.guid} style={{marginBottom: "12px"}}>
                                <div style={{display: "flex", alignItems: "flex-start", gap: "24px"}}>
                                  <div style={{flex: 3}}>
                                    {benefit.type} - {<strong>{currencyCode + " " + (benefit.cover_amount_in_cents / 100).toLocaleString()}</strong>}
                                  </div>
                                  <div style={{flex: 2}}>
                                    <p style={{margin: 0}}>Waiting Period Start Date</p>
                                    <h6>{formatDateLocale(benefit.waiting_period_start_date) || "N/A"}</h6>
                                  </div>
                                  <div style={{flex: 1}}>
                                    <p style={{margin: 0}}>Waiting Period (Days)</p>
                                    <h6>{benefit.waiting_period_in_days != null ? benefit.waiting_period_in_days + " days" : "N/A"}</h6>
                                  </div>
                                </div>
                              </li>
                            )
                          })
                        }
                      </ol>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

            </>
          ))
        }
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            {
              dataForDisplay.length > 1 && (
                <Button style={{
                  background: "#FBA92D",
                  borderRadius: "8px",
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "15px",
                  boxShadow: "none",
                  padding: "10px",
                  marginTop: "20px",
                  textTransform: "capitalize",
                }} variant="contained" size="large" endIcon={expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} onClick={() => setExpanded(!expanded)}>
                  {expanded ? `Show Less` : `Show More`}
                </Button>
              )
            }


          </Grid>
        </Grid>

      </>

    )
  } else {
    return "No Dependants Found"
  }

}

export default Dependants